import { render, staticRenderFns } from "./ProformasNav.vue?vue&type=template&id=0d978b86&"
import script from "./ProformasNav.vue?vue&type=script&lang=js&"
export * from "./ProformasNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports